import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { INavContent } from '@garmin/components-global-web';
import { IconComponent } from '@garmin-avcloud/avcloud-fly-web-common/shared';

@Component({
  selector: 'fly-navigation',
  imports: [IconComponent, RouterModule],
  templateUrl: './navigation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent {
  protected readonly navContent: InputSignal<INavContent[]> = input.required();

  protected toggleCategoryItemOpen(navItem: INavContent): void {
    navItem.isOpen = !(navItem.isOpen ?? false);
  }
}
